// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OnboardingPresentationTemplatesQueryVariables = Types.Exact<{
  currentUserId: Types.Scalars['ID']['input'];
  systemTemplateWhere: Types.PresentationTemplateWhereInput;
}>;


export type OnboardingPresentationTemplatesQuery = { __typename?: 'Query', availablePresentationTemplatePins: Array<(
    { __typename?: 'PresentationTemplate' }
    & OnboardingPresentation_PresentationTemplateFragment
  )>, userTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & OnboardingPresentation_PresentationTemplateFragment
      ) | null } | null> | null }, tenantTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & OnboardingPresentation_PresentationTemplateFragment
      ) | null } | null> | null }, systemTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & OnboardingPresentation_PresentationTemplateFragment
      ) | null } | null> | null } };

export type CompleteHouseholdOnboardingMutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  presentationTemplateIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type CompleteHouseholdOnboardingMutation = { __typename?: 'Mutation', completeHouseholdOnboarding: { __typename?: 'WorkflowTracker', id: string } };

export type OnboardingPresentation_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, tenantID: string, luminaryOrganizationID?: string | null, systemTemplateKind?: Types.PresentationTemplateSystemTemplateKind | null, bundles: { __typename?: 'PresentationTemplateBundleConnection', edges?: Array<{ __typename?: 'PresentationTemplateBundleEdge', node?: { __typename?: 'PresentationTemplateBundle', id: string, kind: Types.PresentationBundleKind, index: number, documentSummaryTemplateBundleConfiguration?: { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string, documentType?: Types.PresentationDocumentType | null, includeFirstGrantor: boolean, includeSecondGrantor: boolean } | null, pages: { __typename?: 'PresentationTemplatePageConnection', edges?: Array<{ __typename?: 'PresentationTemplatePageEdge', node?: { __typename?: 'PresentationTemplatePage', id: string, kind: Types.PresentationPageKind, customPage?: { __typename?: 'PresentationTemplateCustomPage', id: string, pageName: string, customPrompt?: string | null, systemPromptKey?: Types.PresentationTemplateCustomPageSystemPromptKey | null } | null, coverPage?: { __typename?: 'PresentationTemplateCoverPage', id: string, displayTitle?: string | null, customPrompt?: string | null, systemPromptKey?: Types.PresentationTemplateCoverPageSystemPromptKey | null } | null, diagramPage?: { __typename?: 'PresentationTemplateDiagramPage', id: string, pageName: string } | null } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    OnboardingPresentationTemplates: 'OnboardingPresentationTemplates' as const
  },
  Mutation: {
    CompleteHouseholdOnboarding: 'CompleteHouseholdOnboarding' as const
  },
  Fragment: {
    OnboardingPresentation_PresentationTemplate: 'OnboardingPresentation_PresentationTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const OnboardingPresentation_PresentationTemplateFragmentDoc = gql`
    fragment OnboardingPresentation_PresentationTemplate on PresentationTemplate {
  id
  displayName
  tenantID
  luminaryOrganizationID
  systemTemplateKind
  bundles(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        id
        kind
        index
        documentSummaryTemplateBundleConfiguration {
          id
          documentType
          includeFirstGrantor
          includeSecondGrantor
        }
        pages {
          edges {
            node {
              id
              kind
              customPage {
                id
                pageName
                customPrompt
                systemPromptKey
              }
              coverPage {
                id
                displayTitle
                customPrompt
                systemPromptKey
              }
              diagramPage {
                id
                pageName
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const OnboardingPresentationTemplatesDocument = gql`
    query OnboardingPresentationTemplates($currentUserId: ID!, $systemTemplateWhere: PresentationTemplateWhereInput!) {
  availablePresentationTemplatePins {
    ...OnboardingPresentation_PresentationTemplate
  }
  userTemplates: presentationTemplates(
    where: {and: [{type: USER_TEMPLATE}, {hasUserWith: [{id: $currentUserId}]}, {systemTemplateKindIsNil: true}]}
  ) {
    edges {
      node {
        ...OnboardingPresentation_PresentationTemplate
      }
    }
  }
  tenantTemplates: presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, {systemTemplateKindIsNil: true}]}
  ) {
    edges {
      node {
        ...OnboardingPresentation_PresentationTemplate
      }
    }
  }
  systemTemplates: presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, $systemTemplateWhere]}
  ) {
    edges {
      node {
        ...OnboardingPresentation_PresentationTemplate
      }
    }
  }
}
    ${OnboardingPresentation_PresentationTemplateFragmentDoc}`;

/**
 * __useOnboardingPresentationTemplatesQuery__
 *
 * To run a query within a React component, call `useOnboardingPresentationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingPresentationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingPresentationTemplatesQuery({
 *   variables: {
 *      currentUserId: // value for 'currentUserId'
 *      systemTemplateWhere: // value for 'systemTemplateWhere'
 *   },
 * });
 */
export function useOnboardingPresentationTemplatesQuery(baseOptions: Apollo.QueryHookOptions<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>(OnboardingPresentationTemplatesDocument, withFetchPolicyContext(options));
      }
export function useOnboardingPresentationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>(OnboardingPresentationTemplatesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useOnboardingPresentationTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>(OnboardingPresentationTemplatesDocument, withFetchPolicyContext(options));
        }
export type OnboardingPresentationTemplatesQueryHookResult = ReturnType<typeof useOnboardingPresentationTemplatesQuery>;
export type OnboardingPresentationTemplatesLazyQueryHookResult = ReturnType<typeof useOnboardingPresentationTemplatesLazyQuery>;
export type OnboardingPresentationTemplatesSuspenseQueryHookResult = ReturnType<typeof useOnboardingPresentationTemplatesSuspenseQuery>;
export type OnboardingPresentationTemplatesQueryResult = Apollo.QueryResult<OnboardingPresentationTemplatesQuery, OnboardingPresentationTemplatesQueryVariables>;
export const CompleteHouseholdOnboardingDocument = gql`
    mutation CompleteHouseholdOnboarding($householdID: ID!, $presentationTemplateIDs: [ID!]!) {
  completeHouseholdOnboarding(
    householdID: $householdID
    presentationTemplateIDs: $presentationTemplateIDs
  ) {
    id
  }
}
    `;
export type CompleteHouseholdOnboardingMutationFn = Apollo.MutationFunction<CompleteHouseholdOnboardingMutation, CompleteHouseholdOnboardingMutationVariables>;

/**
 * __useCompleteHouseholdOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteHouseholdOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteHouseholdOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeHouseholdOnboardingMutation, { data, loading, error }] = useCompleteHouseholdOnboardingMutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      presentationTemplateIDs: // value for 'presentationTemplateIDs'
 *   },
 * });
 */
export function useCompleteHouseholdOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteHouseholdOnboardingMutation, CompleteHouseholdOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteHouseholdOnboardingMutation, CompleteHouseholdOnboardingMutationVariables>(CompleteHouseholdOnboardingDocument, options);
      }
export type CompleteHouseholdOnboardingMutationHookResult = ReturnType<typeof useCompleteHouseholdOnboardingMutation>;
export type CompleteHouseholdOnboardingMutationResult = Apollo.MutationResult<CompleteHouseholdOnboardingMutation>;
export type CompleteHouseholdOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteHouseholdOnboardingMutation, CompleteHouseholdOnboardingMutationVariables>;